// /coaching/* + /admin/users/:id/coaching Wrapper.

import { apiFetch } from './api';

export type CoachingPlan = 'quarterly' | 'half_yearly' | 'yearly';
export type CoachingStatus = 'active' | 'past_due' | 'canceled';
export type CoachingSource = 'stripe' | 'manual';

export interface CoachingSubscription {
  id: string;
  plan: CoachingPlan;
  status: CoachingStatus;
  source: CoachingSource;
  period_start: string;
  period_end: string;
  stripe_subscription_id: string | null;
  cancel_at_period_end: boolean;
}

export interface CoachingBooking {
  id: string;
  calcom_booking_id: string;
  scheduled_at: string;
  duration_min: number;
  status: 'scheduled' | 'completed' | 'no_show' | 'canceled';
}

export interface CoachingMeResponse {
  subscription: CoachingSubscription | null;
  upcoming_bookings: ReadonlyArray<CoachingBooking>;
  past_bookings: ReadonlyArray<CoachingBooking>;
  bookings_this_week: number;
}

export async function fetchCoachingMe(accessToken: string): Promise<CoachingMeResponse> {
  return apiFetch<CoachingMeResponse>('/coaching/me', { accessToken });
}

export async function createCheckoutSession(
  accessToken: string,
  plan: CoachingPlan,
): Promise<{ url: string }> {
  return apiFetch<{ url: string }>('/coaching/checkout', {
    method: 'POST',
    accessToken,
    json: { plan },
  });
}

export async function openCustomerPortal(accessToken: string): Promise<{ url: string }> {
  return apiFetch<{ url: string }>('/coaching/portal', {
    method: 'POST',
    accessToken,
  });
}

// Admin
export interface ActivateCoachingInput {
  plan: CoachingPlan;
  period_end: string;
  notes?: string;
}

export async function activateCoaching(
  accessToken: string,
  userId: string,
  input: ActivateCoachingInput,
): Promise<{ ok: true; id: string }> {
  return apiFetch(`/admin/users/${userId}/coaching`, {
    method: 'POST',
    accessToken,
    json: input,
  });
}

export interface PatchCoachingInput {
  plan?: CoachingPlan;
  period_end?: string;
  notes?: string;
}

export async function patchCoaching(
  accessToken: string,
  userId: string,
  input: PatchCoachingInput,
): Promise<{ ok: true }> {
  return apiFetch(`/admin/users/${userId}/coaching`, {
    method: 'PATCH',
    accessToken,
    json: input,
  });
}

export async function cancelCoaching(
  accessToken: string,
  userId: string,
): Promise<{ ok: true }> {
  return apiFetch(`/admin/users/${userId}/coaching`, {
    method: 'DELETE',
    accessToken,
  });
}
